import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { ISideNavItems } from '../../models/side-menu';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

interface menu {
  name: string;
  icon: string;
  submenu: submenu[];
}

interface submenu {
  name: string;
  path: string;
  icon: string;
}

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;

  fillerNav = ISideNavItems;
  currentNavName: string = '';
  // Property to control sidenav state
  isSidenavOpen = true;

  private _mobileQueryListener: () => void;
  matchedNav: any;
  currentRoute: string | undefined;
  parentNav: menu = {
    name: '',
    icon: '',
    submenu: [],
  };
  currentParentNav: string | null = '';
  currentSubNav: string | null = '';
  //{ name: string; icon: string; submenu: { name: string; path: string; icon: string; }[]; };

  constructor(private router: Router) {
    const changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher) as MediaMatcher;

    this.mobileQuery = media.matchMedia('(max-width: 400px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.currentParentNav = sessionStorage.getItem('parentNav')
      ? sessionStorage.getItem('parentNav')
      : '';
    this.currentSubNav = sessionStorage.getItem('currentNavName')
      ? sessionStorage.getItem('currentNavName')
      : '';
    // Listen for route changes and update the currentNavName based on the active route
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute = this.router.url.split('/').pop(); // Get the current route name
        // Try to find the matched nav in main items or their submenus
        this.matchedNav =
          this.fillerNav.find(
            (nav) =>
              nav.name.toLowerCase() === this.currentRoute?.toLowerCase(),
          ) ||
          this.fillerNav
            .flatMap((nav) => nav.submenu || [])
            .find(
              (subNav) =>
                subNav.name.toLowerCase() === this.currentRoute?.toLowerCase(),
            ) ||
          '';

        // Append the matched name to fillerNav if found and not already present
        // Find the parent navigation item for the matchedNav (if matchedNav is a submenu)

        const navItem = this.fillerNav.find(
          (nav) =>
            nav.name === this.matchedNav.name ||
            (nav.submenu &&
              nav.submenu.some(
                (subNav) => subNav.name === this.matchedNav.name,
              )),
        );
        if (navItem) this.parentNav = navItem;
        this.currentNavName = this.matchedNav ? this.matchedNav.name : '';
        sessionStorage.setItem('parentNav', this.parentNav.name);
        sessionStorage.setItem('currentNavName', this.currentNavName);
      });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  getMenuId(name: string): string {
    return `menu_${name}`;
  }
}
